import styled from '@emotion/styled';
import { Modal, theme } from '@travelnest/hui';
import StyledHeading from '../../components/typography/StyledHeading';
import StyledText from '../../components/typography/StyledText';

export const GradientLeft = styled.div`
	height: 100%;
	width: 50%;
	background: linear-gradient(180deg, #0090FF21, #fff);
	position: absolute;
	top: 0;
	left: 0;
	filter: blur(20px);
`;

export const GradientRight = styled.div`
	height: 100%;
	width: 50%;
	background: linear-gradient(180deg, #FF040017, #fff);
	position: absolute;
	top: 0;
	right: 0;
	filter: blur(20px);
`;

export const ModalContent = styled.div`
	max-width: 600px;
`;

export const StyledModal = styled(Modal)`
	text-align: center;
	img {
	 z-index: 100;
	 height: 200px;
		margin-bottom: ${theme.spacing.space80};
	}
	#modal-footer {
		justify-content: center;
		margin-bottom: ${theme.spacing.space20};
	}
	#modal-content {
		display: flex;
		flex-direction: column;
		align-items: center;
	}
`;

export const StyledParagraph = styled(StyledText)`
	color: ${theme.colors.LM_NU70T};
	margin-top: ${theme.spacing.space30};
	margin-bottom: ${theme.spacing.space50};
	margin-right: ${theme.spacing.space40};
	margin-left: ${theme.spacing.space40};
	z-index: 10;
	position: relative;
`;

export const StyledTitle = styled(StyledHeading)`
	color: ${theme.colors.LM_NU100};
	margin: 0;
`;

export const ModalTitle = styled(StyledTitle)`
	z-index: 10;
	position: relative;
`;
